module.exports = __webpack_public_path__ + "static/media/GPG179A_H59_RD.04c319e5.jpg";